import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CloseIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
var popupImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/casual-limit-popup_930ae547.svg";
import * as styles from './casual-limit-popup.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Popup = _ref => {
  var maxAllowed = _ref.maxAllowed,
    onClose = _ref.onClose,
    onSignUp = _ref.onSignUp,
    onSignIn = _ref.onSignIn;
  var containerRef = useRef();
  var closePopup = evt => {
    var _containerRef$current;
    if (!(containerRef !== null && containerRef !== void 0 && (_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(evt.target))) {
      onClose();
    }
  };
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', closePopup, false);
    }
    return () => {
      if (typeof document !== 'undefined') {
        document.removeEventListener('mousedown', closePopup, false);
      }
    };
  });
  return ___EmotionJSX("div", {
    css: styles.popup,
    ref: containerRef
  }, ___EmotionJSX("button", {
    type: "button",
    onClick: onClose,
    css: styles.closeButton,
    "aria-label": "close"
  }, ___EmotionJSX(CloseIcon, {
    size: "small"
  })), ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX("img", {
    src: popupImage,
    alt: ""
  }), ___EmotionJSX("div", {
    css: styles.contentMiddle
  }, ___EmotionJSX("div", {
    css: styles.title
  }, "Want more inspections?"), ___EmotionJSX("div", {
    css: styles.message
  }, "Sign up or log in to add more than ", maxAllowed, " inspections."), ___EmotionJSX("div", {
    css: styles.buttonGroup
  }, ___EmotionJSX(Button, {
    css: styles.button,
    onClick: onSignUp
  }, "Sign me up"), ___EmotionJSX(Button, {
    css: styles.button,
    appearance: "ghost",
    onClick: onSignIn
  }, "Log in")))));
};
Popup.propTypes = {
  onClose: PropTypes.func,
  onSignUp: PropTypes.func,
  onSignIn: PropTypes.func,
  maxAllowed: PropTypes.number.isRequired
};
Popup.defaultProps = {
  onClose: () => {},
  onSignUp: () => {},
  onSignIn: () => {}
};
export default Popup;